module.exports = "/_next/static/images/c1ea68b41e93a674b2b8108d1d1f6126-heart.svg";